// Shilpadoc.jsx
import React from 'react'
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import shilpadocImg from '../../../../assets/images/Doctorsimages/dr.shilpa.png' 
import favicon from "../../../../assets/images/favicon.ico"
import AutoScrollImageRow from '../../AdvancedTreatmentsforHome/AutoScrollImageRow'
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

const Shilpadoc = () => {
  const navigate = useNavigate(); 

  useEffect(() => {
    document.title = "Dr. Shilpa Vikas | Expert Homeopathy, Cosmetology & Nutrition Specialist | H-Cura Multispeciality Clinic";
    
    const metaDescription = document.querySelector("meta[name='description']");
    if (metaDescription) {
      metaDescription.setAttribute(
        "content",
        "Consult Dr. Shilpa Vikas (BHMS, MSc Psychology), a renowned expert in Homeopathy and Medical Cosmetology at H-Cura Multispeciality Clinic. With 18+ years of experience and 20,000+ patients treated, she specializes in holistic healing and aesthetic wellness."
      );
    }

    const metaKeywords = document.querySelector("meta[name='keywords']");
    if (metaKeywords) {
      metaKeywords.setAttribute(
        "content",
        "best homeopathy doctor, medical cosmetology specialist, homeopathy for skin and hair, certified nutritionist for weight management, holistic health consultant, Dr. Shilpa Vikas homeopathy, H-Cura multispeciality clinic, homeopathy for chronic diseases, skin rejuvenation treatments, psychological wellness and health, weight loss consultant homeopathy, top homeopathy consultant, advanced cosmetology treatments, female homeopathy doctor, restorative health and beauty"
      );
    }

    const existingCanonical = document.querySelector("link[rel='canonical']");
    const canonicalUrl = "https://www.h-cura.com/doctors/dr-shilpa-homeopathy-aesthetic-consultant-bangalore";
    if (existingCanonical) {
      existingCanonical.setAttribute("href", canonicalUrl);
    } else {
      const canonicalLink = document.createElement("link");
      canonicalLink.setAttribute("rel", "canonical");
      canonicalLink.setAttribute("href", canonicalUrl);
      document.head.appendChild(canonicalLink);
    }

    const existingFavicon = document.querySelector("link[rel='icon']");
    if (existingFavicon) {
      existingFavicon.setAttribute("href", favicon);
    } else {
      const faviconLink = document.createElement("link");
      faviconLink.setAttribute("rel", "icon");
      faviconLink.setAttribute("type", "image/x-icon");
      faviconLink.setAttribute("href", favicon);
      document.head.appendChild(faviconLink);
    }
  }, []);

  const handleDownloadPdf = () => {
    const container = document.querySelector('.veenadoc');
    container.classList.add('veenadoc-pdf-mode');

    const originalStyles = new Map();
    const allElements = container.querySelectorAll('*');
    
    allElements.forEach(el => {
      originalStyles.set(el, {
        transition: el.style.transition,
        animation: el.style.animation,
        transform: el.style.transform,
        filter: el.style.filter
      });
      el.style.transition = 'none';
      el.style.animation = 'none';
      el.style.transform = 'none';
      el.style.filter = 'none';
    });

    const heroSection = container.querySelector('.veenadoc-hero-section');
    if (heroSection) {
      heroSection.style.minHeight = 'auto';
      heroSection.style.padding = '40px 0';
    }

    const images = container.querySelectorAll('img');
    images.forEach(img => {
      img.style.opacity = '1';
      img.style.display = 'block';
    });

    setTimeout(() => {
      html2canvas(container, {
        scale: 2,
        dpi: 300,
        useCORS: true,
        allowTaint: false,
        backgroundColor: '#ffffff',
        logging: true,
        windowWidth: container.scrollWidth,
        windowHeight: container.scrollHeight,
        imageTimeout: 0
      }).then(canvas => {
        container.classList.remove('veenadoc-pdf-mode');
        
        allElements.forEach(el => {
          const original = originalStyles.get(el);
          el.style.transition = original.transition;
          el.style.animation = original.animation;
          el.style.transform = original.transform;
          el.style.filter = original.filter;
        });

        if (heroSection) {
          heroSection.style.minHeight = '';
          heroSection.style.padding = '';
        }

        const imgData = canvas.toDataURL('image/jpeg', 0.95);
        const pdf = new jsPDF('p', 'mm', 'a4', true);
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = pdf.internal.pageSize.getHeight();
        
        const marginLeft = 10;
        const marginRight = 10;
        const availableWidth = pdfWidth - marginLeft - marginRight;
        const scaleFactor = availableWidth / canvas.width;
        const imgWidth = canvas.width * scaleFactor;
        const imgHeight = canvas.height * scaleFactor;

        const pages = Math.ceil(imgHeight / pdfHeight);

        for (let i = 0; i < pages; i++) {
          if (i > 0) pdf.addPage();
          pdf.addImage(imgData, 'JPEG', marginLeft, -i * pdfHeight, imgWidth, imgHeight, undefined, 'FAST');
        }

        pdf.save('Dr.Shilpa_Vikas_Profile.pdf');
      }).catch(err => {
        console.error("PDF Generation Error:", err);
        container.classList.remove('veenadoc-pdf-mode');
      });
    }, 500);
  };

  return (
    <>
      <div className="veenadoc">
        {/* Hero Section */}
        <div className="veenadoc-hero-section">
          <div className="veenadoc-hero-background">
            <div className="veenadoc-wave-pattern">
              <svg viewBox="0 0 1200 320" className="veenadoc-wave-svg" preserveAspectRatio="none">
                <path d="M0,96L48,112C96,128,192,160,288,186.7C384,213,480,235,576,213.3C672,192,768,128,864,128C960,128,1056,192,1152,208C1248,224,1344,192,1392,176L1440,160L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z" fill="rgba(46, 125, 50, 0.1)"></path>
              </svg>
            </div>
            <div className="veenadoc-floating-shapes">
              <div className="veenadoc-shape veenadoc-shape-1"></div>
              <div className="veenadoc-shape veenadoc-shape-2"></div>
              <div className="veenadoc-shape veenadoc-shape-3"></div>
              <div className="veenadoc-shape veenadoc-shape-4"></div>
            </div>
          </div>

          <div className="veenadoc-container">
            <div className="veenadoc-hero-content">
              <div className="veenadoc-hero-left">
                <h1 className="veenadoc-hero-title">
                  <span className="veenadoc-title-highlight">Dr. Shilpa Vikas</span>
                  <span className="veenadoc-title-credentials">(BHMS, MSc Psych, FMC)</span>
                  <span className="veenadoc-title-location">Bangalore</span>
                </h1>

                <div className="veenadoc-hero-description">
                  <p>
                    A highly distinguished practitioner with over <strong>18</strong> years of clinical excellence and a legacy of treating <strong>20,000+</strong> patients, currently leading as the Director of Homeopathy and Cosmetology at <strong>H-Cura Multispeciality Clinic</strong>. She is widely recognized for her ability to integrate internal healing with external aesthetic enhancement.
                  </p>
                </div>

                <div className="veenadoc-hero-actions">
                  <button className="veenadoc-btn-primary-gradient" onClick={() => navigate('/bookconsultation')}>
                    <span className="veenadoc-btn-icon">📞</span>
                    <span>Book Consultation</span>
                    <div className="veenadoc-btn-shine"></div>
                  </button>
                </div>
              </div>

              <div className="veenadoc-hero-right">
                <div className="veenadoc-doctor-showcase">
                  <div className="veenadoc-doctor-frame">
                    <div className="veenadoc-frame-glow"></div>
                    <div className="veenadoc-image-container">
                      <img 
                        src={shilpadocImg} 
                        alt="Dr. Shilpa Vikas – Director of Homeopathy and Cosmetology" 
                        className="veenadoc-doctor-image" 
                        crossOrigin="anonymous"
                        title='Dr. Shilpa Vikas – Director of Homeopathy and Cosmetology' 
                      />
                      <div className="veenadoc-image-overlay"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Article Content */}
        <div className="veenadoc-article-section">
          <div className="veenadoc-container">
            <div className="veenadoc-article-layout">
              <div className="veenadoc-article-main">
                
                {/* Introduction */}
                <div className="veenadoc-article-block">
                  <h2>About Dr. Shilpa Vikas</h2>
                  <p>
                    Dr. Shilpa Vikas is an alumna of the prestigious <strong>Rajiv Gandhi University and Annamalai University</strong>. Her academic journey is marked by a commitment to continuous learning, having completed advanced fellowships and certifications from renowned institutions such as <strong>ILLAMED, Medversity, and the Othersong Academy.</strong> 
                  </p>
                  <p>
                    With <strong>18 years</strong> of practice and over <strong>20,000+ patients</strong> successfully treated, she has established herself as a leader in holistic healthcare. This deep expertise allows her to address complex health issues using the latest homeopathic methodologies alongside modern aesthetic science.
                  </p>
                </div>

                {/* Homeopathy Before & After Section */}
                <div className="veenadoc-article-block" style={{ backgroundColor: '#f9fdf9', padding: '25px', borderRadius: '12px', border: '1px solid #e0eee0', marginBottom: '30px' }}>
                  <h2 style={{ color: '#2e7d32', marginBottom: '20px' }}>Homeopathy: The Transformation Journey</h2>
                  <p>
                    Dr. Shilpa’s homeopathic approach focuses on "Constitutional Healing," where the treatment is tailored to the individual's unique physical and mental makeup. Here is the typical transformation seen in her patients:
                  </p>
                  
                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px', marginTop: '20px' }}>
                    <div style={{ background: '#fff', padding: '20px', borderRadius: '10px', boxShadow: '0 4px 6px rgba(0,0,0,0.05)' }}>
                      <h4 style={{ color: '#d32f2f', borderBottom: '2px solid #ffcdd2', paddingBottom: '10px', display: 'flex', alignItems: 'center' }}>
                        <span style={{ marginRight: '10px' }}>🔴</span> Before Treatment
                      </h4>
                      <ul style={{ listStyle: 'none', padding: '10px 0' }}>
                        <li style={{ marginBottom: '10px' }}>• Recurrent chronic symptoms</li>
                        <li style={{ marginBottom: '10px' }}>• Dependency on temporary relief/suppressants</li>
                        <li style={{ marginBottom: '10px' }}>• Low immunity and frequent relapses</li>
                        <li style={{ marginBottom: '10px' }}>• Psychological stress due to physical ailments</li>
                        <li style={{ marginBottom: '10px' }}>• Unaddressed root causes</li>
                      </ul>
                    </div>
                    
                    <div style={{ background: '#fff', padding: '20px', borderRadius: '10px', boxShadow: '0 4px 6px rgba(0,0,0,0.05)' }}>
                      <h4 style={{ color: '#2e7d32', borderBottom: '2px solid #c8e6c9', paddingBottom: '10px', display: 'flex', alignItems: 'center' }}>
                        <span style={{ marginRight: '10px' }}>🟢</span> After Treatment
                      </h4>
                      <ul style={{ listStyle: 'none', padding: '10px 0' }}>
                        <li style={{ marginBottom: '10px' }}>• Permanent resolution of the root cause</li>
                        <li style={{ marginBottom: '10px' }}>• Strengthened natural immune system</li>
                        <li style={{ marginBottom: '10px' }}>• Sustainable wellness without side effects</li>
                        <li style={{ marginBottom: '10px' }}>• Improved mental clarity and vitality</li>
                        <li style={{ marginBottom: '10px' }}>• Holistic harmony of Mind & Body</li>
                      </ul>
                    </div>
                  </div>
                  
                  <p style={{ marginTop: '20px', fontStyle: 'italic', color: '#555' }}>
                    *Results are achieved through meticulous case-taking and advanced homeopathic protocols refined over 18 years of clinical experience.
                  </p>
                </div>

                {/* Clinical Journey */}
                <div className="veenadoc-article-block">
                  <h2>Clinical Journey & Leadership</h2>
                  <p>
                    Throughout her 18-year career, Dr. Shilpa has held significant leadership roles, including serving as a Senior Homeo Consultant and Branch Head at Homeocare International and a Senior Consultant at Vital Care.
                  </p>
                  <p>
                    Currently, as a senior leader at <strong>H-Cura Multispeciality Clinic</strong>, she leads a team dedicated to patient-centric care, focusing on the root cause of ailments rather than just the symptoms.
                  </p>
                </div>

                <div className="veenadoc-sidebar-card">
                  <h3>Quick Information</h3>
                  <div className="veenadoc-info-grid">
                    <div className="veenadoc-info-item">
                      <span className="veenadoc-info-label">Qualification:</span>
                      <span className="veenadoc-info-value">BHMS, MSc Psych, FMC</span>
                    </div>
                    <div className="veenadoc-info-item">
                      <span className="veenadoc-info-label">Experience:</span>
                      <span className="veenadoc-info-value">18+ Years</span>
                    </div>
                    <div className="veenadoc-info-item">
                      <span className="veenadoc-info-label">Specialization:</span>
                      <span className="veenadoc-info-value">Homeopathy, Cosmetology & Nutrition</span>
                    </div>
                    <div className="veenadoc-info-item">
                      <span className="veenadoc-info-label">Clinic:</span>
                      <span className="veenadoc-info-value">H-Cura Multispeciality</span>
                    </div>
                  </div>
                </div>

                {/* Mind-Body-Beauty */}
                <div className="veenadoc-article-block">
                  <h2>The "Mind-Body-Beauty" Approach</h2>
                  <p>
                    What sets Dr. Shilpa apart is her integrated approach. With her background in Psychology and Nutrition, she understands that true health is reflected in one’s physical appearance and mental well-being.
                  </p>
                  <p>
                    She is a sought-after consultant for weight management and lifestyle disorders, helping patients achieve sustainable health goals through personalized nutritional guidance and homeopathic support.
                  </p>
                </div>

                {/* Aesthetic Medicine */}
                <div className="veenadoc-article-block">
                  <h2>Advanced Medical Cosmetology</h2>
                  <p>
                    Her expertise in Medical Cosmetology makes her a trusted name for patients seeking non-invasive solutions for skin rejuvenation, hair fall, pigmentation, and anti-aging.
                  </p>
                  <p>
                    By combining the safe, long-term benefits of Homeopathy with advanced aesthetic procedures, she ensures that her patients achieve a natural, youthful radiance that begins from within.
                  </p>
                </div>
                
                <div className="veenadoc-article-block">
                  <h2>Media Presence & Celebrity Care</h2>
                  <p>
                    Dr. Shilpa Vikas is a trusted name among high-profile individuals, with over <strong>50+ celebrities</strong> seeking her expertise for specialized skin and hair treatments. 
                  </p>
                  <p>
                    Beyond her clinical practice, she is a prominent voice in medical education, having delivered between <strong>600 to 700 educative TV talks</strong>. Her expert insights have been featured across major networks including <strong>TV9, Praja TV, Suvarna News, BTV, Public TV, and News 18 Kannada</strong>.
                  </p>
                </div>

                <div className="veenadoc-article-block">
                  <h2>Specialized Trichology & Hair Care Solutions</h2>
                  <p>
                    Dr. Shilpa Vikas has gained recognition as a trichology doctor in Bangalore specializing in hair fall, dandruff, scalp conditions, hair thinning, premature greying, alopecia, and hair regrowth treatments. She also provides advanced hair therapies such as PRP, GFC, Mesotherapy, Stem Cell Therapy, Laser Hair Therapy and exosome to ensure effective and long-lasting results.
                  </p>
                </div>

                {/* Conclusion */}
                <div className="veenadoc-article-block veenadoc-conclusion-block">
                  <h2>Choose Dr. Shilpa Vikas for Total Wellness</h2>
                  <p>
                    Patients who consult Dr. Shilpa Vikas value her empathetic listening, her vast clinical knowledge, and her dedication to achieving visible, lasting results. Whether you are seeking treatment for chronic health conditions or advanced skin care, she offers a professional path to total wellness at H-Cura.
                  </p>
                  <p className="veenadoc-mission-statement">
                    <strong>Her mission:</strong> To empower patients with healthier lives, glowing skin, stronger hair, and renewed confidence.
                  </p>
                </div>
              </div>

              {/* Sidebar */}
              <div className="veenadoc-article-sidebar">
                <div className="veenadoc-article-block veenadoc-philosophy-block">
                  <div className="veenadoc-philosophy-quote">
                    <div className="veenadoc-quote-icon">💫</div>
                    <blockquote style={{ fontSize: '1.1rem' }}>
                      "A good doctor treats the disease, but a great doctor restores health, youth, and beauty."
                    </blockquote>
                    <p className="veenadoc-quote-attribution">— Dr. Shilpa Vikas's Philosophy</p>
                  </div>
                  <p>
                    This vision drives her practice at H-Cura, ensuring that every individual receives a customized treatment plan tailored to their unique constitution.
                  </p>
                </div>

                <div className="veenadoc-sidebar-card">
                  <h3>Practice Locations</h3>
                  <div className="veenadoc-location-item">
                    <div className="veenadoc-location-icon">📍</div>
                    <div className="veenadoc-location-details">
                      <h4>Bangalore</h4>
                      <p>H-Cura Multispeciality Clinic</p>
                    </div>
                  </div>
                </div>

                <div className="veenadoc-sidebar-card veenadoc-cta-card">
                  <h3>Book Your Consultation</h3>
                  <p>Experience restorative healthcare with Dr. Shilpa's 18+ years of expertise and 20,000+ successful treatments at H-Cura.</p>
                  <button className="veenadoc-sidebar-btn-primary" onClick={() => window.location.href = 'tel:+919964688333'}>
                    <span>📞</span>
                    <span>Schedule Appointment</span>
                  </button>
                  <button className="veenadoc-sidebar-btn-secondary" onClick={() => window.location.href = 'tel:+919964688333'}>
                    <span>💬</span>
                    <span>Get Free Assessment</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <AutoScrollImageRow/>

      <div className="bangloregfcblog-download-section">
        <button className="bangloregfcblog-download-button" onClick={handleDownloadPdf}>
          Download This Doctor profile as PDF
        </button>
      </div>
        
    </>
  )
}

export default Shilpadoc;
